// extracted by mini-css-extract-plugin
export default {"container":"companyCard_container__hUWdG","logo_box":"companyCard_logo_box__0mfDK","logo":"companyCard_logo__ibPNJ","infoContainer":"companyCard_infoContainer__xTQI6"};